<template>
  <div id="content">
    <div class="rankingTable__header">{{ $t('rankingHeaderAll') }}</div>
    <ranking-cell
      v-for="result in results"
      :key="result.name"
      :result="result"
    ></ranking-cell>
  </div>
</template>

<script>
import RankingCell from './RankingCell.vue'

export default {
  components: {
    RankingCell,
  },
  name: 'GameRankingTable',
  data: function () {
    return {
      isEnableBottom: true,
    }
  },
  props: {
    results: Array,
  },
  methods: {
    handleScroll: function (event) {
      const scrolling =
        (document.documentElement.scrollTop || document.body.scrollTop) +
        document.documentElement.offsetHeight -
        document.documentElement.scrollHeight
      if (scrolling >= -70 && this.isEnableBottom) {
        this.isEnableBottom = false
        setTimeout(this.enableBottom, 500)
        this.$emit('scrolledToBottom')
      }
    },
    enableBottom() {
      this.isEnableBottom = true
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
    this.isEnableBottom = true
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    this.isEnableBottom = false
  },
}
</script>
<style scoped>
.rankingTable__header {
  width: 100%;
  max-width: 500px;
  height: 40px;
  font-family: Hiragino Kaku Gothic ProN;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 40px;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
